export const BaseUrl = "https://www.api.zinco.co.in"
// export const BaseUrl = "http://192.168.1.95:8005"
export const UserData = JSON.parse(localStorage.getItem("UserCredentials"));